import React, { useState, useEffect, useReducer } from 'react'
import { Modal, Button, Table, Form, Input } from 'semantic-ui-react'
import { numFormat } from '@rededompedro/utils'
import InputMask from 'react-input-mask'

export default function ModalItem({ item, restaurante, setShowModalItem, setItemLista }) {

    const initialFormValues = {
        data_emissao: item.data_emi,
        data_vencto: item.data_vencto,
        tipo_pagto: item.tipo,
        valor: item.valor,
        obs: item.obs
    }

    function formReducer(state, action) {
        if ('reset' in action)
            return initialFormValues
        if (!('payload' in action))
            return state
        return { ...state, ...action.payload }
    }

    const options = [
        { text: 'Merc. Revenda', value: '02' },
        { text: 'Merc. Consumo', value: '03' },
        { text: 'Salário', value: '04' },
        { text: 'Impostos', value: '05' },
        { text: 'Outras Despesas', value: '06' },
        { text: 'Manutenção/Conserto', value: '07' },
        { text: 'Investimentos', value: '08' }
    ]

    const [open, setOpen] = useState(false)
    const [alterar, setAlterar] = useState(false)
    const [form, setForm] = useReducer(formReducer, initialFormValues)

    useEffect(() => {
        if (item) {
            setOpen(true)
            console.log(item)
        }
    }, [item])

    function showAlterar() {
        if (alterar === false) {
            setAlterar(true)
        } else {
            setAlterar(false)
            setForm({ reset: true })
        }
    }

    function handleChange(event) {
        let name, value
        [name, value] = [event.target.name, event.target.value]
        setForm({ payload: { [name]: value } })
    }

    function handleChangeSelect(_, { name, value }) {
        setForm({ payload: { [name]: value } })
    }

    function handleSubmit() {
        console.log(form)
    }

    return (
        <Modal size={'small'} open={open}>
            <Modal.Header>{restaurante}</Modal.Header>
            <Modal.Content scrolling>
                <Table definition compact='very'>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>Empresa</Table.Cell>
                            <Table.Cell>{restaurante}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Nº Controle</Table.Cell>
                            <Table.Cell>{item.n_controle}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Data da Comanda de Pagto</Table.Cell>
                            <Table.Cell>{item.data_n_controle}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Data de emissão</Table.Cell>
                            <Table.Cell>
                                {alterar === false ? (
                                    <>
                                        {item.data_emi}
                                    </>
                                ) :
                                    <Form size='mini'>
                                        <Form.Field>
                                            <Input
                                                children={
                                                    <InputMask mask="99/99/9999" value={form.data_emissao} name='data_emissao' onChange={handleChange} />
                                                }
                                            />
                                        </Form.Field>
                                    </Form>
                                }
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Data de vencimento</Table.Cell>
                            <Table.Cell>
                                {alterar === false ? (
                                    <>
                                        {item.data_vencto}
                                    </>
                                ) :
                                    <Form size='mini'>
                                        <Form.Field>
                                            <Input
                                                children={
                                                    <InputMask mask="99/99/9999" value={form.data_vencto} name='data_vencto' onChange={handleChange} />
                                                }
                                            />
                                        </Form.Field>
                                    </Form>
                                }
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Nº Item Pagto</Table.Cell>
                            <Table.Cell>{item.item_pagto}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Nº Docto</Table.Cell>
                            <Table.Cell>{item.docto}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Tipo</Table.Cell>
                            <Table.Cell>
                                {alterar === false ? (
                                    <>
                                        {item.descricao}
                                    </>
                                ) :
                                    <Form size='mini'>
                                        <Form.Select
                                            size='mini'
                                            options={options}
                                            search
                                            selectOnBlur={false}
                                            placeholder='Selecionar o Tipo'
                                            name='tipo_pagto'
                                            value={form.tipo_pagto}
                                            onChange={handleChangeSelect}
                                        />
                                    </Form>
                                }
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Valor Pagto</Table.Cell>
                            <Table.Cell>
                                {alterar === false ? (
                                    <>
                                        R$ {numFormat(item.valor)}
                                    </>
                                ) :
                                    <Form size='mini'>
                                        <Form.Field
                                            control={Input}
                                            value={form.valor}
                                            name='valor'
                                            onChange={handleChange}
                                        />
                                    </Form>
                                }
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Observações</Table.Cell>
                            <Table.Cell>
                                {alterar === false ? (
                                    <>
                                        {item.obs}
                                    </>
                                ) :
                                    <Form size='mini'>
                                        <Form.Field
                                            control={Input}
                                            value={form.obs}
                                            name='obs'
                                            onChange={handleChange}
                                        />
                                    </Form>
                                }
                            </Table.Cell>
                        </Table.Row>
                        {alterar === true &&
                            <Table.Row>
                                <Table.Cell colSpan='2'>
                                    <Button size='tiny' floated='right' positive content='Salvar' onClick={() => handleSubmit()} />
                                </Table.Cell>
                            </Table.Row>
                        }
                    </Table.Body>
                </Table>
            </Modal.Content>

            {item.status === 0 ? (
                <Modal.Actions>
                    <Button color='orange' icon='download' labelPosition='right' content='Baixar' />
                    <Button primary icon='checkmark' labelPosition='right' content='Alterar' onClick={() => showAlterar()} />
                    <Button icon='close' labelPosition='right' content='Excluir' />
                    <Button negative onClick={() => { setShowModalItem(false); setOpen(false); setItemLista(null) }}>Fechar</Button>
                </Modal.Actions>
            ) :
                <Modal.Actions>
                    <Button negative onClick={() => { setShowModalItem(false); setOpen(false); setItemLista(null) }}>Fechar</Button>
                    <Button positive content='Alterar Pagto Rede / Voltar em Aberto' />
                </Modal.Actions>
            }


        </Modal>
    )
}